import { createTheme, Theme } from '@mui/material/styles';

import { colors } from 'constants-colors';

function createMuiTheme(fontFamily: string): Theme {
  return createTheme({
    palette: {
      primary: {
        main: colors.darkGreen,
      },
      secondary: {
        main: colors.errorOLD,
      },
      success: {
        main: colors.accent,
      },
    },
    typography: {
      fontFamily: [fontFamily, 'Helvetica', 'Arial', 'sans-serif'].join(','),
    },
  });
}

export { createMuiTheme };
export default createMuiTheme('Inter');
